export default __webpack_public_path__ + "media/images/social-2a8670a253baadb09387aff92b7beb21.png";